import i18next from "src/i18n/config";
import AuthService from "src/services/authService";
import { downloadFromBlob } from "src/ui/utils/download";

import { requestDownloadBuildLog, requestStreamBuildLog } from "@dashboard/products/api";
import TimeService from "@services/timeService/timeService";
import { showErrorToast } from "@shared/toasts/Toasts";

export function getReasonMessage(hasLogs: boolean) {
    if (!hasLogs) {
        return i18next.t("common:section.logStreamer.noLogsAvailable");
    }
    return i18next.t("common:section.logStreamer.showBuildLogs");
}
export function onStartStreaming(buildId: number) {
    const token = AuthService.getSession()?.access_token;
    if (!token) {
        throw new Error(i18next.t("common:section.logStreamer.errorRetrievingLogs"));
    }
    return requestStreamBuildLog(buildId, token);
}
export async function onDownloadLog(buildId: number) {
    try {
        const { data } = await requestDownloadBuildLog(buildId);
        if (!data?.size) {
            return showErrorToast(i18next.t("common:section.logStreamer.logFileEmpty"));
        }

        const name = `log${buildId}_${TimeService.getNowInFormat("yyyy-LL-dd")}`;
        downloadFromBlob(data, name);
    } catch (_error) {
        showErrorToast(i18next.t("common:section.logStreamer.downloadLogsFailed"));
    }
}
